import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, EMPTY, Observable, takeUntil, tap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { LOGIN_ENDPOINT } from '../config/config.constants';
import { NgxSpinnerService } from 'ngx-spinner';
import { SKIP_AUTH_INTERCEPTOR } from './skip-auth.context';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService,
    private spinner: NgxSpinnerService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip interceptor if context flag is set
    if (req.context.get(SKIP_AUTH_INTERCEPTOR)) {
      return next.handle(req);
    }

    // NON intercettare chiamate a Keycloak (per RuleEngine auth)
    if (req.url.includes(environment.ruleEngine?.keycloak?.authority || 'dev-iam.actiaitaliaserviceprovider.com')) {
      return next.handle(req);
    }

    // NON intercettare chiamate a RuleEngine API (usa già token Keycloak)
    if (req.url.includes(environment.ruleEngine?.apiUrl || 'localhost:4000')) {
      return next.handle(req);
    }

    // NON intercettare chiamate UControl API: Authorization viene gestito da UcontrolAuthInterceptor
    if (req.url.includes(environment.ucontrol?.apiUrl || 'uc-diaglight.dts1.actiafleet.com')) {
      return next.handle(req);
    }

    // NON intercettare chiamate al Keycloak di UControl (token endpoint, autenticazione client_credentials)
    if (req.url.includes(environment.ucontrol?.keycloak?.authority || 'iam.actiaitaliaserviceprovider.com')) {
      return next.handle(req);
    }

    let token = localStorage.getItem("token");
    //if (token != null) {
      const modifiedReq = req.clone({
        headers: req.headers
          .set('Authorization', `Bearer ${token}`)
      });

      if (req.url.includes(LOGIN_ENDPOINT)) {
        // Sul login un 401/errore è "credenziali errate": nessun auto-logout,
        // nessun takeUntil(logout$) che tronchi la risposta. Deve arrivare
        // intatta al login.component, che la gestisce da solo.
        return next.handle(modifiedReq);
      }

      return next.handle(modifiedReq).pipe(
        takeUntil(this.authService.logout$),
        catchError((err: any) => {
          if (err instanceof HttpErrorResponse && err.status === 401) {
            // trigger logout (emit on logout$ and cancel other requests)
            this.authService.sessionExpired();
            // Aggiorna anche lo stato interno del servizio, non solo il DOM:
            // altrimenti il prossimo <ngx-spinner> montato (es. sul login) lo rilegge come "visibile".
            this.spinner.hide();
            const spinners = document.querySelectorAll('ngx-spinner');
            spinners.forEach(spinner => {
              (spinner as HTMLElement).style.display = 'none';
            });
            const spinnersOverlay = document.querySelectorAll('.ngx-spinner-overlay');
            spinnersOverlay.forEach(overlay => {
              (overlay as HTMLElement).style.display = 'none';
            });
            return EMPTY;
          }
          return throwError(() => err);
        })
        /* tap(() => { }, (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status !== 401) {
              return;
            }
            this.authService.logOut();
          }
        }) */
      );
    //}
    /* return next.handle(req).pipe(tap(() => { }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status !== 401) {
          return;
        }
        this.authService.logOut();
      }
    })); */
  }
}
